import React from "react";
import { Offcanvas } from "react-bootstrap";
import { redirectToDifferentPage } from "../../../../../../../utils/constants/constants";

const ShareModal = ({
  isOpen,
  storeName,
  shortlink,
  toggleCanvas,
  landingPageTitle,
}) => {
  const shareText = `I had a great time at ${storeName}, I think you will too 😄

Register on this link and get ${landingPageTitle} on your first purchase 🎁
    
Click here to register: ${shortlink}`;

  const encodedShareText = encodeURIComponent(shareText);

  const copyText = () => {
    navigator.clipboard.writeText(shareText);
    toggleCanvas();
  };

  const shareWhatsapp = () => {
    redirectToDifferentPage(
      `https://api.whatsapp.com/send?text=${encodedShareText}`
    );
    toggleCanvas();
  };

  const shareFb = () => {
    redirectToDifferentPage(
      `https://www.facebook.com/sharer/sharer.php?u=${shortlink}`
    );
    toggleCanvas();
  };

  const shareLinkedIn = () => {
    redirectToDifferentPage(
      `https://www.linkedin.com/sharing/share-offsite/?url=${shortlink}`
    );
    toggleCanvas();
  };

  const shareTwitter = () => {
    redirectToDifferentPage(
      `https://twitter.com/intent/tweet?text=${encodedShareText}`
    );
    toggleCanvas();
  };

  return (
    <Offcanvas
      show={isOpen}
      placement="bottom"
      onHide={toggleCanvas}
      className="share-shortlink-canvas"
    >
      <Offcanvas.Body>
        <div className="canvas-header">
          <span>
            <img src="/assets/icons/share.svg" alt="back" /> Share
          </span>
          <img
            alt="close"
            width="18px"
            onClick={toggleCanvas}
            className="close-icon"
            src="/assets/icons/close.svg"
          />
        </div>
        <div className="canvas-body">
          <div className="share-button" onClick={copyText}>
            <img
              width="32px"
              src="/assets/icons/social-icons/copy-2.svg"
              alt="copy"
            />
            <p>Copy</p>
          </div>
          <div className="share-button" onClick={shareWhatsapp}>
            <img
              width="32px"
              src="/assets/icons/social-icons/whatsapp-2.svg"
              alt="copy"
            />
            <p>Whatsapp</p>
          </div>
          <div className="share-button" onClick={shareFb}>
            <img
              width="32px"
              src="/assets/icons/social-icons/fb-new.svg"
              alt="copy"
            />
            <p>Facebook</p>
          </div>
          <div className="share-button" onClick={shareLinkedIn}>
            <img
              width="32px"
              src="/assets/icons/social-icons/linkedin.svg"
              alt="copy"
            />
            <p>LinkedIn</p>
          </div>
          <div className="share-button" onClick={shareTwitter}>
            <img
              width="32px"
              src="/assets/icons/social-icons/twitter-new.svg"
              alt="copy"
            />
            <p>Twitter</p>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ShareModal;
